import { PLANTS, SERIES } from '@/helpers/constants';
import { uniqueSeriesPlants } from '@/redux/Campaign/campaign.utils';

export const initVolumeObject = (currentPlant, activeLanguages, typeOfSelection) => {
  const volume = {
    plant: currentPlant.wkzNumber || '',
    fileOptionSelected: typeOfSelection === 'PLANTS',
    vehicleRestrictionFiles: [],
    limitationVolumeManualEntry: {
      countryVariantsComment: {},
      countryVariantsSelecteds: [],
      countryVariantsSelectionAccording: 'AFFECTED',
      aggregateComment: {},
      aggregateSelecteds: [],
      aggregateSelectionAccording: 'AFFECTED',
      paintCodeComment: {},
      paintCodeSelecteds: [],
      paintCodeSelectionAccording: 'AFFECTED',
      specialEquipmentComment: {},
      specialEquipmentSelecteds: [],
      specialEquipmentSelectionAccording: 'AFFECTED',
      vehicleModelDesignationComment: {},
      vehicleModelDesignationSelecteds: [],
      vehicleModelDesignationSelectionAccording: 'AFFECTED',
      codeRules: [],
      vehicleGroups: [],
    },
  };

  activeLanguages.forEach((language) => {
    volume.limitationVolumeManualEntry.countryVariantsComment[language.languageCode] = '';
    volume.limitationVolumeManualEntry.aggregateComment[language.languageCode] = '';
    volume.limitationVolumeManualEntry.paintCodeComment[language.languageCode] = '';
    volume.limitationVolumeManualEntry.specialEquipmentComment[language.languageCode] = '';
    volume.limitationVolumeManualEntry.vehicleModelDesignationComment[language.languageCode] = '';
  });

  return volume;
};

export default initVolumeObject;

export function uniquePlants(typeVersions) {
  const plants: any = Object.values(typeVersions).flat();
  const plantsHashMap = plants.reduce((hashMap, plant) => ({ ...hashMap, [plant.wkzNumber]: plant }), {});
  const unique = Object.keys(plantsHashMap).map((wkzNumber) => plantsHashMap[wkzNumber]);

  return unique;
}

export function mapAffectedVehicle(affVehicles) {
  return ({
    ...affVehicles,
    affectedPlants: affVehicles?.affectedPlants?.map((plant) => ({
      ...plant,
      affectedSeries: plant.affectedSeries?.reduce((acc, serie) => ({
        ...acc, [serie.modelSerie]: serie.typeVersions,
      }), {}),
    })),
  }
  );
}

export function seriesToArray(response) {
  return response?.map((serie) => ({
    serie: serie.modelSerie,
    checked: false,
    typeVersions: serie.typeVersions.reduce((acc, row) => ({
      ...acc,
      [row.typeVersion]: row.plants,
    }), {}),
  }));
}

export function seriesToObject(data) {
  return {
    series: data.reduce((acc, row) => ({
      ...acc,
      [row.serie]: Object.keys(row.typeVersions).map((tv) => ({ typeVersion: tv, plants: row.typeVersions[tv] })),
    }), {}),
  };
}

export const checkVehiclesSelectionVia = (affVehicles, type) => affVehicles?.typeOfAffectedPlantsSelection === type;
export const isViaPlants = (affVehicles) => checkVehiclesSelectionVia(affVehicles, PLANTS);
export const isViaModelSeries = (affVehicles) => checkVehiclesSelectionVia(affVehicles, SERIES);

export const plantsHaveFiles = (noCheckedRows, volumes, headerPlants, isViaPlant = false) => {
  const newAffectedPlants = isViaPlant ? noCheckedRows : uniqueSeriesPlants(noCheckedRows);

  return headerPlants.filter(({ wkzNumber }) => !newAffectedPlants.some((p) => p.wkzNumber === wkzNumber))
    .filter(({ wkzNumber }) => volumes.find(({ plant }) => plant === wkzNumber)?.vehicleRestrictionFiles?.length > 0);
};

export const mapPlantsWithfiles = (plants) => plants.map(({ plantName }) => plantName).join(', ');

export const validateSeries = (validations, affectedVehicles, setValidations, headerLanguage) => {
  if (validations?.active?.all) {
    const { affectedPlants, series } = affectedVehicles;
    const vehiclesValidations = validations?.affectedVehicles;
    const noRows = isViaPlants(affectedVehicles) ? affectedPlants?.length === 0 : series?.length === 0;
    const newState = {
      ...vehiclesValidations,
      [headerLanguage]: {
        ...vehiclesValidations?.[headerLanguage],
        ...(noRows
          ? { volumes: {}, seriesInvalid: true }
          : { seriesInvalid: false }),
      },
    };
    setValidations(newState);
  }
};
